import axios from "axios";
import {API_URL} from "../config";

let trunksPhonesInflight: Promise<any> | null = null;
let allAudioInGroupsInflight: Promise<any> | null = null;

export function fetchTrunksPhonesCatalog(jwtToken: string): Promise<any> {
    if (!trunksPhonesInflight) {
        trunksPhonesInflight = axios.get(`${API_URL}Trunks/GetTrunksPhones`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => response.data.data)
            .finally(() => {
                trunksPhonesInflight = null;
            });
    }
    return trunksPhonesInflight;
}

export function fetchAllAudioInGroupsCatalog(jwtToken: string): Promise<any> {
    if (!allAudioInGroupsInflight) {
        allAudioInGroupsInflight = axios.get(`${API_URL}Audio/GetAllAudioInGroups?isActive=true`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => response.data.data)
            .finally(() => {
                allAudioInGroupsInflight = null;
            });
    }
    return allAudioInGroupsInflight;
}
